import { MailFilled } from "@ant-design/icons";
import { Alert, Divider, Form, Input, Typography } from "antd";
import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { useStateIfMounted } from "use-state-if-mounted";
import ActionBtn from "../../shared/action-btn";
import { ROUTE_PUBLIC_SIGN_IN } from "../../shared/app-constants";
import { ForgotPasswordData } from "../../shared/forgot-password-data";
import getErrorMessage from "../../shared/get-error-msg";
import getPublicRoute from "../../shared/get-public-route";
import HttpClient from "../http-client";

interface ForgotPasswordPageProps {}

const organizationCheckCache: any = {};

const ForgotPasswordPage: FunctionComponent<ForgotPasswordPageProps> = () => {
  const [busy, setBusy] = useStateIfMounted(false);
  const [serverMsg, setServerMsg] = useStateIfMounted<string | undefined>(
    undefined
  );
  const [serverMsgType, setServerMsgType] = useStateIfMounted<
    "error" | "success" | undefined
  >(undefined);

  const next = async (ForgotPasswordData: ForgotPasswordData) => {
    setBusy(true);
    setServerMsg(undefined);
    try {
      await HttpClient.post("user/forgot-password", ForgotPasswordData);
      setServerMsgType("success");
      setServerMsg("A password reset link has been sent to your email!");
    } catch (error: any) {
      if (error?.response?.data?.error) {
        setServerMsgType("error");
        setServerMsg(getErrorMessage(error?.response?.data));
      }
    }
    setBusy(false);
  };
  return (
    <div className="form-container">
      <Form onFinish={next} className="public-form">
        <Typography.Title level={4} className="title">
          Forgot Password
        </Typography.Title>
        {!serverMsg && (
          <Typography.Text className="my-1 display-block" type="secondary">
            Provide your email. We will send a password reset instruction to
            your email.
          </Typography.Text>
        )}
        {serverMsg && (
          <Alert
            type={serverMsgType}
            message={serverMsg}
            style={{ marginBottom: 10 }}
          />
        )}
        <Form.Item
          name="email"
          rules={[
            { required: true, type: "email", message: "Email is required!" },
          ]}
        >
          <Input
            type={"email"}
            suffix={<MailFilled />}
            placeholder="Your organization email!"
          />
        </Form.Item>
        <Form.Item>
          <ActionBtn
            busy={busy}
            type="primary"
            htmlType="submit"
            className="button"
          >
            Next
          </ActionBtn>
          <Divider orientation="center">Or</Divider>
          <div className="tc">
            <Link to={{ pathname: getPublicRoute({}, ROUTE_PUBLIC_SIGN_IN) }}>
              Login
            </Link>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ForgotPasswordPage;
